import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propAny, propBool, propChildren, propFunc, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
const Select2MultipleInputOnlyOption = (props) => {
    const { children, className, cx, data, getStyles, innerProps, innerRef, isDisabled, isFocused, isSelected, } = props;
    return (_jsx("div", Object.assign({ "aria-disabled": isDisabled, className: cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected,
        }, className), "data-react-select-value": data.value, ref: innerRef, style: getStyles('option', props) }, innerProps, { children: children })));
};
Select2MultipleInputOnlyOption.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    cx: propFunc().isRequired,
    data: propShape().isRequired,
    getStyles: propFunc().isRequired,
    innerProps: propShape().isRequired,
    innerRef: propAny(),
    isDisabled: propBool().isRequired,
    isFocused: propBool().isRequired,
    isSelected: propBool().isRequired,
    selectProps: propShape().isRequired,
};
Select2MultipleInputOnlyOption.defaultProps = {
    className: '',
    innerRef: null,
};
export default Select2MultipleInputOnlyOption;
